import DueDatePicker from "@/components/DueDatePicker/dueDatePicker.component";
import AssigneePicker from "@/components/PersonPickerDropdown/assigneePicker.component";
import { Input } from "@/shadcn/components/ui/input";
import { NewTask } from "@/types";
import { formatDueDate } from "@/utils/utils";
import { set } from "date-fns";
import React, { useEffect } from "react";

type CreateSubTaskProps = {
  newSubTask: NewTask;
  setNewSubTask: React.Dispatch<React.SetStateAction<NewTask>>;
};

const CreateSubTask: React.FC<CreateSubTaskProps> = ({
  newSubTask,
  setNewSubTask,
}) => {
  function handleEditField(field: keyof NewTask, value: string) {
    console.log(field, value);
    setNewSubTask((prev) => ({ ...prev, [field]: value }));
  }

  function handleFieldAssignedTo(value: number) {
    console.log(value);
    try {
      if (isNaN(value)) {
        console.log("Invalid user ID: ", value);
        return;
      }
      setNewSubTask((prev) => ({ ...prev, assigned_to: value }));
    } catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    console.log(newSubTask);
  }, [newSubTask]);

  function handleFieldDueDate(value: Date | undefined | null) {
    if (!value) {
      setNewSubTask((prev) => ({ ...prev, due_date: null }));
      return;
    }
    const date = set(new Date(), {
      year: value.getFullYear(),
      month: value.getMonth(),
      date: value.getDate(),
    });
    const formatted = formatDueDate(date);
    setNewSubTask((prev) => ({ ...prev, due_date: formatted }));
  }

  return (
    <div className="flex flex-row gap-2">
      {/* Title */}
      <Input
        id="create-title"
        value={newSubTask.title}
        onChange={(e) => {
          handleEditField("title", e.target.value);
        }}
        maxLength={255}
      />
      {/* Assignee */}
      <AssigneePicker
        assignedTo={newSubTask.assigned_to!}
        handleFieldAssignedTo={handleFieldAssignedTo}
        modal={false}
      />
      {/* Due Date */}
      <div className="flex-shrink">
        <DueDatePicker
          modal={false}
          dueDate={newSubTask.due_date ? new Date(newSubTask.due_date) : null}
          onDateChange={handleFieldDueDate}
        />
      </div>
    </div>
  );
};

export default CreateSubTask;
